import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Button = styled.button`
    flex: 1;
    padding: 1em;
    line-height: 0;
    background-color: ${props =>
        props.disabled && !props.isSubmitting
            ? 'white'
            : props.primary
            ? '#ff245e'
            : 'white'};
    border: solid 1px
        ${props =>
            props.disabled && !props.isSubmitting
                ? '#e5e3e3'
                : props.primary
                ? '#ff245e'
                : '#e5e3e3'};
    color: ${props =>
        props.disabled && !props.isSubmitting
            ? '#cbc8c8'
            : props.primary
            ? '#ffffff'
            : '#072647'};
    font-family: Averta;
    font-weight: 600;
    font-size: 16px;
    height: 46px;
    cursor: ${props => (props.disabled ? `not-allowed` : `pointer`)};
    border-radius: 4px;
    position: relative;

    &:hover {
        ${props =>
            !props.primary &&
            `
                color: #fff;
                background-color: #072647;
            `};
    }

    @media (max-width: 22em) {
        padding: 1em 6px;
    }
`;

const PhoneNumber = styled.a`
    color: #fff;
    text-decoration: none;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    line-height: 100%;
    padding: calc(1em - 2px);
`;

const Label = styled.span``;

const ButtonComponent = props => (
    <Button
        type={props.type || 'button'}
        {...props}
        disabled={props.disabled || props.isSubmitting}
    >
        {!!props.normalizedPhone && props.normalizedPhone !== '' ? (
            <PhoneNumber target="_parent" href={`tel:${props.normalizedPhone}`}>
                {props.label}
            </PhoneNumber>
        ) : (
            <Label>{props.label}</Label>
        )}
    </Button>
);

ButtonComponent.propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.string.isRequired,
    type: PropTypes.string,
    primary: PropTypes.bool,
    onClick: PropTypes.func,
    normalizedPhone: PropTypes.string,
    isMobileResolution: PropTypes.bool,
    isSubmitting: PropTypes.bool
};

export default ButtonComponent;
